module.exports = __webpack_public_path__ + "img/s0.46b75cce.png";